import * as colors from '../assets/styles/custom/variables.module.scss';

// const breakpoints = {}

type TThemeColors = {
  // main colors
  mainblue: string;
  dark: string;
  gray: string;
  white: string;

  // secondary colors
  graysoft: string;
  gray2: string;
  gray3: string;
  gray4: string;
  red: string;
  green: string;
  orange: string;
  yellow: string;
  bluelight: string;
  greenlight: string;
  redlight: string;
  chart: string;
  subscribe: string;
};

export enum FONT_FAMILY {
  MEDIUM = 'medium',
  REGULAR = 'regular',
  SEMIBOLD = 'semibold',
  BOLD = 'bold',
}

export enum COLORS {
  MAINBLUE = 'mainblue',
  DARK = 'dark',
  GRAY = 'gray',
  WHITE = 'white',
  GRAYSOFT = 'graysoft',
  GRAY2 = 'gray2',
  GRAY3 = 'gray3',
  GRAY4 = 'gray4',
  RED = 'red',
  GREEN = 'green',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  BLUELIGHT = 'bluelight',
  GREENLIGHT = 'greenlight',
  REDLIGHT = 'redlight',
  CHART = 'chart',
  SUBSCRIBE = 'subscribe',
}

type TTheme = {
  colors: TThemeColors;
};
const theme: TTheme = { colors: colors.default as TThemeColors };

export default theme;
